import { Marketing } from 'lib/templates/Feature.BOKF.model';
import { ComponentProps } from 'lib/component-props';

export type LayoutProps = Marketing.DataTemplates.CarouselMarquee & ComponentProps;

export type CarouselMarqueeProps = {
  fields: {
    children: Marketing.DataTemplates.CarouselMarqueeSlide[];
  };
} & LayoutProps;
